import { MenuItem } from "@mui/material";
import { PositionRoleEnum } from "@sinch/core/entities/serverEnums";
import React from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { MdsIcon, useMuiController } from "@sinch/components";
import { usePositionRole } from "@sinch/components/application/PositionRole/PositionRole";
import { SelectInput, SelectInputProps } from "@sinch/components/form/SelectInput/SelectInput";

type RoleInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<SelectInputProps, "defaultValue" | "ref"> & ReturnType<typeof useMuiController<TFieldValues, TName>>["field"];

export const RoleInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  params: RoleInputProps<TFieldValues, TName>
) => {
  const { getRoleColor, getRoleLabel, getRoleIconXs, getSortedRoles } = usePositionRole();

  return (
    <SelectInput<PositionRoleEnum>
      data-cy="role-input"
      size="small"
      {...params}
      disabled={params.disabled}
      renderValue={(selected: PositionRoleEnum) => (
        <>
          <MdsIcon
            fontSize="small"
            icon={getRoleIconXs(selected)}
            sx={(theme) => ({
              marginRight: theme.spacing(1),
              color: getRoleColor(selected),
            })}
          />
          {getRoleLabel(selected)}
        </>
      )}
    >
      {getSortedRoles().map((role) => (
        <MenuItem key={role} data-cy="role-input-option" value={role}>
          <MdsIcon
            fontSize="small"
            icon={getRoleIconXs(role)}
            sx={(theme) => ({
              marginRight: theme.spacing(1),
              color: getRoleColor(role),
            })}
          />
          {getRoleLabel(role)}
        </MenuItem>
      ))}
    </SelectInput>
  );
};
